import axios, { AxiosError, type AxiosInstance } from 'axios';
import { basicAuthHeader, readCredentials } from '@/auth/storage';

const baseURL = import.meta.env.VITE_API_BASE_URL as string | undefined;
if (!baseURL) {
  // eslint-disable-next-line no-console
  console.error('VITE_API_BASE_URL is not defined — check your .env file');
}

let currentWorkspace: { orgId: string | null; botId: string | null } = {
  orgId: null,
  botId: null,
};

export function setApiWorkspace(orgId: string | null, botId: string | null): void {
  currentWorkspace = { orgId, botId };
}

export function getApiWorkspace(): { orgId: string | null; botId: string | null } {
  return currentWorkspace;
}

export const http: AxiosInstance = axios.create({
  baseURL,
  timeout: 30_000,
});

http.interceptors.request.use((config) => {
  const creds = readCredentials();
  if (creds) {
    config.headers = config.headers ?? {};
    config.headers.Authorization = basicAuthHeader(creds);
  }
  if (currentWorkspace.orgId) {
    config.headers = config.headers ?? {};
    config.headers['X-Org-Id'] = currentWorkspace.orgId;
  }
  if (currentWorkspace.botId) {
    config.headers = config.headers ?? {};
    config.headers['X-Bot-Id'] = currentWorkspace.botId;
  }
  return config;
});

http.interceptors.response.use(
  (res) => res,
  (err: AxiosError) => {
    if (err.response?.status === 401) {
      window.dispatchEvent(new CustomEvent('zorro-ai:auth-cleared'));
    }
    return Promise.reject(err);
  },
);

export function unwrapError(err: unknown): string {
  if (err instanceof AxiosError) {
    const data = err.response?.data as { error?: string; message?: string } | undefined;
    return data?.error ?? data?.message ?? err.message;
  }
  if (err instanceof Error) return err.message;
  return String(err);
}
